module.exports = __webpack_public_path__ + "img/whatsapp.4d2598f6.svg";